import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  withCredentials: false
})

export default instance
